/* eslint-disable */
//tslint:disable

export var EInfrastructureCategory;
(function (EInfrastructureCategory) {
  EInfrastructureCategory["Cafe"] = "cafe";
  EInfrastructureCategory["Clinic"] = "clinic";
  EInfrastructureCategory["Grocery"] = "grocery";
  EInfrastructureCategory["Nursery"] = "nursery";
  EInfrastructureCategory["School"] = "school";
})(EInfrastructureCategory || (EInfrastructureCategory = {}));